<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="备货退货单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备货退货单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col v-if="!system_setting.IsFirWarehouseStockMode"  :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="checkNo" label="备货验收" v-if="getIsView()">
                <el-select v-model="form.checkNo" :disabled="!editMode" placeholder="请选择验收单号" filterable :filter-method="getStockUpCheckList" @change="stockUpCheckChange" style="width:100%">
                  <el-option v-for="item in stockUpCheckList" :key="item.id" :label="item.no" :value="item.no"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>备货验收:{{ form.checkNo }} </span>
            </el-col>

            <el-col v-if="system_setting.IsFirWarehouseStockMode"  :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="firstInStockNo" label="一级库备货入库" v-if="getIsView()">
                <el-select v-model="form.firstInStockNo" :disabled="!editMode" placeholder="请选择一级库备货入库" filterable :filter-method="getStockUpFirstInStocks"  @change="StockUpFirstInStockChange" style="width:100%">
                  <el-option v-for="item in STATIC_GetStockUpFirstInStocks" :key="item.id" :label="item.no" :value="item.no"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>一级库备货入库:{{ form.firstInStockNo }} </span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" label="供应商" v-if="getIsView()">
                <el-input disabled v-model="form.supplierName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>供应商:{{ form.supplierName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" label="仓库" v-if="getIsView()">
                <el-select v-model="form.warehouseName" :disabled="!editMode" placeholder="请选择" filterable :filter-method="getWarehouses" @change="warehouseChange" style="width:100%">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>仓库:{{ form.warehouseName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseManagerId" label="库管员" v-if="getIsView()">
                <el-input disabled v-model="form.warehouseManagerName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>库管员:{{ form.warehouseManagerName }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber" type="number"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总数量:{{ form.totalNumber }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="总金额" v-if="getIsView()">
                <el-input type="number" disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总金额:{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="退货理由" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="退货理由" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>退货理由:{{ form.remark }} </span>
            </el-col>
          </el-row>

          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">备货退货明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
            <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button>
            <!-- v-if="system_setting.isUseRfid" -->
            <!-- <el-input :disabled="!editMode" placeholder="rfid"  v-model="rfid" ref="rfidInput" style="width:300px;margin-left:30px" @change="rfidChange"></el-input> -->
            <el-input :disabled="!editMode" placeholder="扫描标签码添加明细" v-model="tagCode" ref="tagCodeInput" style="width:300px;margin-left:30px" @change="tagCodeChange"></el-input>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" :span-method="objectSpanMethod" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column show-overflow-tooltip prop="productName" :key="'productName'" label="产品" fixed width="200"></el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" :key="'specName'" label="规格型号" fixed width="140"></el-table-column>
            <el-table-column prop="supplierProductNo" :key="'supplierProductNo'" label="供应商产品编码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertName" :key="'productRegistCertName'" label="产品注册证" width="180"></el-table-column>
            <!-- <el-table-column prop="brand" label="品牌" width="120"></el-table-column> -->
            <el-table-column show-overflow-tooltip prop="manufacturerName" :key="'manufacturerName'" label="生产厂家" width="180"></el-table-column>
            <el-table-column prop="number" :key="'number'" label="数量" width="120"></el-table-column>
            <el-table-column prop="packSpec" :key="'packSpec'" label="包装规格" width="120"></el-table-column>  
            <el-table-column prop="minUnit" :key="'minUnit'" label="最小单位" width="80"></el-table-column>
            <el-table-column prop="unit" :key="'unit'" label="包装单位" width="80"></el-table-column>
            <el-table-column prop="price" :key="'price'" label="单价" width="120"></el-table-column>
            <el-table-column prop="amount" :key="'amount'" label="小计" width="120"></el-table-column>
            <el-table-column prop="locationName" :key="'locationName'" label="货位" width="120"></el-table-column>
            <el-table-column prop="batch" :key="'batch'" label="批次号" width="120"></el-table-column>
            <el-table-column prop="validityDate" :key="'validityDate'" label="有效期" width="150">
              <template slot-scope="scope">
                {{ scope.row.validityDate? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}") : ""}}
              </template>
            </el-table-column>
            <el-table-column prop="longTime" :key="'longTime'" label="长期" width="80">
              <template slot-scope="scope">
                {{ scope.row.longTime == 1 ? "是" : "否"}}
              </template>
            </el-table-column>
            <el-table-column prop="manufactureDate" :key="'manufactureDate'" label="生产日期" width="150">
              <template slot-scope="scope">
                {{scope.row.manufactureDate ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}") : ""}}
              </template>
            </el-table-column>
            <el-table-column prop="serialNo" label="序列号" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="mainNo" :key="'mainNo'" label="主条码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="traceNo" :key="'traceNo'" label="追溯码" width="180"></el-table-column>
            <el-table-column show-overflow-tooltip prop="onlineNo" :key="'onlineNo'" label="挂网号" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="productRegistCertNo" :key="'productRegistCertNo'" label="注册证号" width="180"></el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip :key="'medicalInsuranceCategoryNo'" label="医保代码" width="200"></el-table-column>
            <el-table-column show-overflow-tooltip  v-show="system_setting.isUseRfid" :key="'rfid_123'"  prop="rfid" label="rfid" width="130">
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :key="'remark_123'" label="备注" width="200"></el-table-column>
            <el-table-column  fixed="right" :key="'operation_123'"  label="标签详情" width="100">
              <template slot-scope="scope">
                <el-button type="text" v-if="scope.row.hasTagCode==1" v-preventReClick class="color-blue" @click="tagCodeView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row v-if="isScan">
            <el-col :span="24">
              <el-form-item label="扫码框">
                <el-input placeholder="请扫码" ref="no" @change="mainNoChange" v-model="childForm.no" @focus="scanInputFocus" @blur="scanInputBlur"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="mainNo" label="主条码">
                <el-input disabled placeholder="请输入主条码" v-model="childForm.mainNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="traceNo" label="追溯码">
                <el-input disabled placeholder="请输入追溯码" v-model="childForm.traceNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="supplierProductNo" label="供应商产品编码">
                <el-input disabled v-model="childForm.supplierProductNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productName" label="产品名称">
                <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>
                <SelectTable v-if="!isScan" :disabled="!editMode" :columns="stockColumns" :innerName="childForm.productName" :dataList="STATIC_Stocks" @filterMethod="getProductList" @change="productChange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="specName" label="规格型号">
                <el-input disabled v-model="childForm.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertId" label="产品注册证">
                <el-input disabled v-model="childForm.productRegistCertName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="childForm.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="onlineNo" label="挂网号">
                <el-input disabled v-model="childForm.onlineNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="brand" label="品牌">
                <el-input disabled v-model="childForm.brand"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="minUnit" label="最小单位">
                <el-input disabled v-model="childForm.minUnit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="unit" label="包装单位">
                <el-input disabled v-model="childForm.unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="packSpec" label="包装规格">
                <el-input disabled v-model="childForm.packSpec"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="disinfectDate" label="灭菌日期">
                <el-date-picker :disabled="!editMode" v-model="childForm.disinfectDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="disinfectBatch" label="灭菌批号">
                <el-input :disabled="!editMode" placeholder="请输入灭菌批号" v-model="childForm.disinfectBatch"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="manufactureDate" label="生产日期">
                <el-date-picker disabled v-model="childForm.manufactureDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择生产日期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="validityDate" label="有效期">
                <el-date-picker disabled v-model="childForm.validityDate" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择有效期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item prop="longTime" label="长期">
                <el-switch v-model="childForm.longTime" disabled active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="batch" label="批次号">
                <el-input disabled placeholder="请输入批次号" v-model="childForm.batch"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="serialNo" label="序列号">
                <el-input disabled placeholder="请输入序列号" v-model="childForm.serialNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="locationName" label="货位">
                <el-input disabled v-model="childForm.locationName"></el-input>
                <!-- <el-select :disabled="!editMode" placeholder="请选择货位" v-model="childForm.locationName" filterable @change="childLocationChange" style="width:100%">
                  <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="number" label="数量">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number" :controls="false" placeholder="请填写数量" @change="autoAmount" style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="price" label="退货价">
                <el-input disabled @input="autoAmount" v-model="childForm.price"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="amount" label="金额">
                <el-input disabled v-model="childForm.amount"></el-input>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" v-model="childForm.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status!=0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData" 
    @tagCodeDelete="tagCodeDelete"
    @close="closeLabelDetailsDialog"/>
    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
    @viewDetails="viewDetails"
     @tagCodeDelete="tagCodeDelete"
     @close="closePackageLabelDialog"/>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import ScanMixin from '@/mixin/outStockScan-mixin'
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  GetStockUpRefundById,
  GetPackViewModels,
  SaveStockUpRefund,
  RejectStockUpRefund,
  GetStockUpChecks,
  GetStockUpCheckById
} from "@/api";
import { StockCategoryOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, ScanMixin,tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    LabelDetailsDialog,
    PackageLabelDialog
  },
  data () {
    return {
      form: {},
      GetDataAction: GetStockUpRefundById,
      SaveDataAction: SaveStockUpRefund,
      reject: RejectStockUpRefund,

      StockCategoryOptions: StockCategoryOptions,
      rules: {
        checkNo: [
          { required: true, message: '请选择备货验收', trigger: 'blur' }
        ],
        firstInStockNo: [
          { required: true, message: '请选择一级库备货入库', trigger: 'blur' }
        ],
        warehouseName: [
          { required: true, message: '请选择仓库', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入退货理由', trigger: 'blur' }
        ],
      },
      childFormRules: {
        productName: [{ required: true, message: "请选择产品信息", trigger: "blur" }],
        price: [
          { required: true, message: "请输入采购价", trigger: "blur" },
        ],
        number: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      isScan: false,
      stockUpCheckList: [],
      rfid: '',
      spanArr: []
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    this.getStockUpFirstInStocks('')
    this.getStockUpCheckList('').then(()=>{
      if(query.refundNo){
        this.form.checkNo = query.refundNo
        this.stockUpCheckChange(query.refundNo)
        GetStockUpCheckById({id:this.form.checkId}).then(res=>{
          this.form.details = res.returnData.details.map(item=>{
            return {...item,
              number : item.unUseNumber,
              amount : item.unUseNumber * item.price,
            }
          })

          this.autoTotalAmount()
        })
      }
    })
    this.getWarehouses("");

  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
        this.getSpanArr(this.form.details)

        this.initWorkFlowProperty(this.form);

      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
         var valdateResult = this.productDetailRepeatValidate(this.form.details);
        if (!valdateResult.flag) {
          this.$my_message(valdateResult.msg, "warning");
          this.$store.dispatch('SetLoading', false)
          return;
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        supplierId: "",
        deliveryTime: new Date(),
        warehouseCategory: "",
        "warehouseId": '',//this.userInfo.defaultWarehouseId,
        warehouseName: '',//this.userInfo.defaultWarehouseName,
        warehouseManagerId: '',//this.userInfo.defaultWarehouseManagerId,
        warehouseManagerName: '',//this.userInfo.defaultWarehouseManagerName,
        totalNumber: 0,
        totalAmount: 0,
        category: 0,
        remark: "",
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        checkNo:'',
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
    handleDeleteChildForm () {
      if(this.checkIsRfid(this.childMultipleSelection)){
        this.$my_message(`存在打包类标签明细，不能删除！`, "warning");
        return
      }
      let rfids = []
      let arr = this.childMultipleSelection.map(item => {
        if (item.rfid) {
          rfids.push(item.rfid)
        }
        return item.$index
      })

      if (rfids && rfids.length > 0) {
        this.form.details = this.form.details.filter(
          (i) => !this.childIds.includes(i.$index) && !rfids.includes(i.rfid)
        );
      }
      else {
        this.form.details = this.form.details.filter(
          (i) => !this.childIds.includes(i.$index)
        );
      }

      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: '',
        "productName": "",
        "specName": "",
        "manufacturerName": "",
        "locationName": "",
        "mainNo": "",
        "traceNo": "",
        supplierProductId: '',
        "productId": '',
        "specId": '',
        productRegistCertId: '',
        "productRegistCertNo": "",
        "onlineNo": "",
        "unit": "",
        "minUnit": "",
        "packSpec": "",
        "manufacturerId": '',
        "locationId": '',
        "manufactureDate": "",
        "batch": "",
        "validityDate": "",
        "serialNo": "",
        "number": 1,
        refundNumber: 0,
        "price": 0,
        "amount": 0,
        rfid: '',
        "remark": "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList('')
    },
    pushChildForm (close) {
      let result = true
      console.log(this.childForm)
      this.$refs["childForm"].validate((valid) => {
        result = valid
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        if (this.childForm.mainNo && this.childForm.traceNo) {
          var childForm = this.childForm
          // 添加行
          let arr = this.form.details.filter(
            (item) => item.mainNo == childForm.mainNo && item.traceNo == childForm.traceNo
          );

          // 添加行记录
          if (arr.length > 0) {
            // 存在则把列表的数据拿过来，并且数量加1
            this.form.details = this.form.details.map((item) => {
              if (
                item.mainNo == childForm.mainNo &&
                item.traceNo == childForm.traceNo
              ) {
                item.packSpec = childForm.packSpec;
                item.locationId = childForm.locationId;
                item.locationName = childForm.locationName;
                item.manufactureDate = childForm.manufactureDate;
                item.batch = childForm.batch;
                item.validityDate = childForm.validityDate;
                item.serialNo = childForm.serialNo;
                item.remark = childForm.remark;
                item.number = childForm.number;
                // item.unUseNumber = childForm.unUseNumber
                item.price = childForm.price;
                item.amount = childForm.amount;
              }
              return item;
            });
          } else {
            // 不存在则添加行记录
            var childForm = JSON.parse(JSON.stringify(this.childForm))
            childForm.$index = this.form.details.length + 1
            this.form.details.push(childForm)
          }
        }
        else {
          if (this.editChildren) {
            let item = this.form.details.find(
              (e) => e.$index == this.childForm.$index
            );
            Object.assign(item, this.childForm);
          }
          else {
            this.form.details.push(this.childForm)
          }
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
          this.count = 0;
          this.isScan = false;
        }

        this.getSpanArr(this.form.details)
      });
      return result
    },
    // childNumberChange () {
    //   // this.childForm.notReceivedNumber = this.childForm.number
    //   // this.childForm.planOrderNumber = this.childForm.number
    //   // this.childForm.actualOrderNumber = this.childForm.number
    //   this.autoAmount();
    // },
    autoAmount () {
      // this.childForm.billingPrice = this.childForm.price
      this.childForm.amount = (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
    },

    // scan
    openScanner (ev) {
      if (!this.form.warehouseId || this.form.warehouseId == "") {
        this.$my_message("请先选择库房", 'warning');
        return;
      }
      this.count = 0;
      this.resetDetailFormData();
      this.isScan = true;
      this.openSubformModal = true;

      ev.target.blur();
    },

    // change event
    stockUpCheckChange (val) {
      let arr = this.stockUpCheckList.filter((item) => item.no == val)[0];
      this.form.checkId = arr.id;
      this.form.supplierName = arr.supplierName
      this.form.supplierId = arr.supplierId
      this.form.warehouseId = arr.warehouseId
      this.form.warehouseName = arr.warehouseName
      this.form.warehouseManagerId = arr.warehouseManagerId
      this.form.warehouseManagerName = arr.warehouseManagerName
   
      this.getProductList('',0);
    },
    StockUpFirstInStockChange(val){
      let arr = this.STATIC_GetStockUpFirstInStocks.filter((item) => item.no == val)[0];
      this.form.stockUpFirstInStockId = arr.id
      this.form.firstInStockNo = arr.no
      // this.form.checkId = arr.id;
      this.form.supplierName = arr.supplierName
      this.form.supplierId = arr.supplierId
      this.form.warehouseId = arr.warehouseId
      this.form.warehouseName = arr.warehouseName
      this.form.warehouseManagerId = arr.warehouseManagerId
      this.form.warehouseManagerName = arr.warehouseManagerName
      this.getProductList('',1);
    },
    locationChange (row) {
      row.locationId = row.locationName
    },
    childLocationChange (val) {
      this.childForm.locationId = val
    },
    supplierChange (val) {
      this.form.supplierId = val;
      this.getProductList('')
      this.form.details = []
    },
    warehouseChange (val) {
      this.form.warehouseId = val
      let arr = this.STATIC_Warehouses.filter(item => item.id == val)
      this.form.warehouseCategoryName = arr[0].category == 1 ? '一级库房' : '二级库房'
      this.form.warehouseCategory = arr[0].category
      this.form.warehouseManagerId = arr[0].managerId
      this.form.warehouseManagerName = arr[0].managerName

      this.getLocations(val)
      this.getProductList('');
    },
    productChange (row) {
      let id = this.childForm.id
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      this.childForm = Object.assign(this.childForm, row)// this.mapper.SupplierProduct2Form(this.childForm, arr[0])
      this.childForm.id = id
      this.childForm.stockId = row.id
      this.childForm.number = 1
      this.childForm.amount = this.childForm.price
      this.childForm.remark = ''

      this.$refs.number.focus();
      this.$refs.number.select();

      this.$refs.childForm.validateField('productName')
    },



    getProductList (keyWord,num ) {
      // query.pageIndex = 1
      // query.pageSize = 50
      // query.warehouseId = this.form.warehouseId
      // query.category = 1
      // query.stockUpCheckId = this.form.checkId
      let query = {
        // userId: this.storage.getItem('user').id,
        pageIndex: 1,
        pageSize: 50,
        keyWord: keyWord,
        warehouseId: this.form.warehouseId,
        category: 1,
        
      }
      if(num == 1){
        query.stockUpFirstInStockId = this.form.stockUpFirstInStockId
      }else{
        query.stockUpCheckId = this.form.checkId
      }
      this.getStocks(query)
    },

    getStockUpCheckList (keyWord) {
      var query = {
        keyWord: keyWord,
        pageIndex: 1, pageSize: 100,
        isShowOtherStatus: 0,
        states: [1, 2],
        warehouseId: this.mySessionStorage.getWarehouseId(), // 存放库房
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId(),
        isReturnState :0
      }
       return new Promise((resolve, reject) => {
          GetStockUpChecks(query)
          .then((res) => {
            this.stockUpCheckList = res.returnData.data;
            resolve(res.returnData.data);
          });
       })
    
    },

    rfidChange (val) {
      if (!val) {
        return;
      }
      this.rfid = ''
      this.$refs['rfidInput'].focus()
       if(val.split(/\s+/)[0]!='B'){
        return
        this.tagCodeChange(val)
      }
      // 如果明细中已存在此rfid，return
      var details = this.form.details.filter(e => e.rfid == val)
      if (details && details.length > 0) {
        return;
      }
      GetPackViewModels({ pageIndex: 1, pageSize: 50, rfid: val, stockCategory: 1 })
        .then(res => {
          if (res.successful) {
            if (!res.returnData.data || res.returnData.data.length == 0) {
              this.$my_message("没有获取到此rfid对应的打包结果", 'warning');
              return
            }
            res.returnData.data.map(item => {
              item.rfid = item.no
              this.form.details.push(item)
            })

            // this.form.details.map((item, index) => {
            //   item.$index = index + 1
            //   return item
            // })

            this.autoTotalAmount()

            this.getSpanArr(this.form.details)
          }
        })
    },
    getSpanArr (data) {
      this.spanArr = []
      if (!data) {
        return
      }
      // data就是我们从后台拿到的数据
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].rfid && data[i].rfid === data[i - 1].rfid) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      // console.log(column)
      // if (column.property == 'rfid') {
      //   const _row = this.spanArr[rowIndex];
      //   const _col = _row > 0 ? 1 : 0;
      //   // console.log(`rowspan:${_row} colspan:${_col}`);
      //   return {
      //     // [0,0] 表示这一行不显示， [2,1]表示行的合并数
      //     rowspan: _row,
      //     colspan: _col
      //   };
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
